"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getFullDeps_1 = __importDefault(require("./getFullDeps"));
var decomposePath_1 = __importDefault(require("./decomposePath"));
var uniq_1 = __importDefault(require("lodash/uniq"));
function expandNodeDeps(dynamic) {
    var paths;
    paths = Object.keys(dynamic.deps);
    dynamic.fullDeps = {};
    for (var i = 0; i < paths.length; i += 1) {
        var path = paths[i];
        //@ts-ignore
        var deps = (0, uniq_1.default)((0, getFullDeps_1.default)(dynamic.deps, path));
        dynamic.fullDeps[path] = deps;
        dynamic.decomposed[path] = (0, decomposePath_1.default)(path);
    }
    paths = Object.keys(dynamic.fullDeps);
    dynamic.staticDeps = {};
    var _loop_1 = function (i) {
        var path = paths[i];
        var deps = dynamic.fullDeps[path];
        deps.forEach(function (x) {
            if (!dynamic.fullDeps[x]) {
                if (!dynamic.staticDeps[x]) {
                    dynamic.staticDeps[x] = [];
                }
                dynamic.staticDeps[x].push(path);
            }
        });
    };
    for (var i = 0; i < paths.length; i += 1) {
        _loop_1(i);
    }
}
exports.default = expandNodeDeps;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhwYW5kTm9kZURlcHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm4vZXhwYW5kTm9kZURlcHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSw4REFBd0M7QUFDeEMsa0VBQTRDO0FBQzVDLHFEQUErQjtBQUUvQixTQUFTLGNBQWMsQ0FBQyxPQUFPO0lBQzdCLElBQUksS0FBSyxDQUFDO0lBRVYsS0FBSyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2xDLE9BQU8sQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0lBRXRCLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDeEMsSUFBSSxJQUFJLEdBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQ3BCLFlBQVk7UUFDWixJQUFJLElBQUksR0FBRyxJQUFBLGNBQUksRUFBQyxJQUFBLHFCQUFXLEVBQUMsT0FBTyxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDO1FBQ2pELE9BQU8sQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDO1FBQzlCLE9BQU8sQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLEdBQUcsSUFBQSx1QkFBYSxFQUFDLElBQUksQ0FBQyxDQUFDO0tBQ2hEO0lBRUQsS0FBSyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ3RDLE9BQU8sQ0FBQyxVQUFVLEdBQUcsRUFBRSxDQUFDOzRCQUVmLENBQUM7UUFDUixJQUFJLElBQUksR0FBRyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDcEIsSUFBSSxJQUFJLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUVsQyxJQUFJLENBQUMsT0FBTyxDQUFDLFVBQUMsQ0FBQztZQUNiLElBQUksQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFO2dCQUN4QixJQUFJLENBQUMsT0FBTyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRTtvQkFDMUIsT0FBTyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUM7aUJBQzVCO2dCQUNELE9BQU8sQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO2FBQ2xDO1FBQ0gsQ0FBQyxDQUFDLENBQUM7O0lBWEwsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQyxJQUFJLENBQUM7Z0JBQS9CLENBQUM7S0FZVDtBQUNILENBQUM7QUFFRCxrQkFBZSxjQUFjLENBQUMifQ==